import { useTranslation } from "react-i18next";
import { ChangeEventItem } from "@/types";
import { RadioGroup, RadioGroupItem } from "@/components/ui/RadioGroup.tsx";
import dayjs from "dayjs";
import Label from "@/components/ui/forms/Label.tsx";
import Button from "@edusogno/primitives/button";

interface StepTwoProps {
  events: ChangeEventItem[];
  onNext: () => void;
  onBack: () => void;
  eventSelect: number;
  onSelect: (value: number) => void;
}

const StepTwo = ({
  events,
  onNext,
  onSelect,
  eventSelect,
  onBack,
}: StepTwoProps) => {
  const { t } = useTranslation();

  return (
    <>
      <header className="flex flex-col items-center">
        <p className="text-primary text-2xl leading-[100%] font-semibold">
          {t("change_event.choose")}
        </p>
      </header>
      
      <div className="flex flex-row items-center justify-between w-full my-[25px]">
        <RadioGroup
          onValueChange={(value) => onSelect(Number(value))}
          defaultValue={eventSelect.toString()}
        >
          {events.map((event) => {
            const date = dayjs(event.data);

            return (
              <div className="flex items-center space-x-2 border border-primary py-2 px-4 rounded-md">
                <RadioGroupItem
                  showRing
                  value={event.id.toString()}
                  id={event.id.toString()}
                />
                <Label htmlFor={event.id.toString()}>
                  <div className="flex flex-col items-start  ml-1">
                    <div className="flex flex-row items-center gap-1">
                      <p className="text-primary uppercase font-semibold text-lg">
                        {`${date.format("ddd").toUpperCase()} ${date.format(
                          "DD",
                        )} ${date.format("MMM")}`}
                        {", "}
                        {event.time}
                      </p>
                    </div>
                  </div>
                </Label>
              </div>
            );
          })}
        </RadioGroup>
      </div>

      <div className="flex gap-2 mt-auto max-w-[95vw] justify-center">
        <Button variant="contained" color="primary" size="md" onClick={onBack}>
          {t("btns.back")}
        </Button>

        <Button
          disabled={!eventSelect}
          variant="contained"
          color="green"
          size="md"
          onClick={onNext}
        >
          {t("btns.choose")}
        </Button>
      </div>
    </>
  );
};

export default StepTwo;
